import React from 'react'
import { WithErrorBoundary } from '../common/ErrorBoundary'

const Mainvistavendedor = WithErrorBoundary(
  'Catalogo',
  'Error en Catalogo',
  React.lazy(() => import('./Mainvistavendedor')),
)
const VistaDetalle = WithErrorBoundary(
  'Catalogo - Detalle de item',
  'Error en Catalogo - Detalle de item',
  React.lazy(() => import('./VistaDetalle')),
)

const SavingPlanDetailView = WithErrorBoundary(
  'Catalogo - Detalle de plan',
  'Error en Catalogo - Detalle de plan',
  React.lazy(() => import('./saving-plan-detail-view/PlanDetailView')),
)
export default {
  path: '/catalogo',
  name: 'Catalogo',
  childRoutes: [
    { path: '', name: 'Mainvistavendedor', component: Mainvistavendedor, isIndex: true },
    { path: 'carDetail/:id', name: 'Vista detalle', component: VistaDetalle },
    { path: 'planDetail/:id', name: 'Vista detalle plan', component: SavingPlanDetailView },

  ],
}
